<template>
  <div id="SetDataPassword">
    <!--    <el-dialog title="重置数据访问密码" :visible="showSelf" id="SetDataPassword">-->
    <!--      <el-form>-->
    <!--        <el-form-item label="公司绑定手机号" label-width="160px">-->
    <!--          <el-input v-model="companyTel" :disabled="true" autocomplete="off"></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="图片验证" class="captcha" v-show="needImgVerifyCode">-->
    <!--          <el-input v-model="imgVerifyCode"></el-input>-->
    <!--          <img id="imgVerifyCode" alt="点击更换" title="点击更换" @click="changeImg">-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="验证码" class="captcha">-->
    <!--          <el-input v-model="captcha"></el-input>-->
    <!--          <el-button type="primary" style="float: right" @click="get_code" v-if="!getCodeDisabled">-->
    <!--            {{ getCaptcha }}-->
    <!--          </el-button>-->
    <!--          <el-button type="primary" style="float: right" disabled v-else>{{ clock }}</el-button>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <div slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="returnBack">取 消</el-button>-->
    <!--        <el-button type="primary" @click="confirm">确 定</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->

    <el-dialog title="重置数据访问密码" :visible="showSelf" :modal-append-to-body="false" :append-to-body="true"
               custom-class="pcPersonCenter_dialog">
      <el-row>
        <el-form label-width="140px" label-position="left">
          <el-form-item label="公司绑定手机号">
            <el-input v-model="companyTel" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="短信验证码：">
            <el-input class="input" v-model="captcha">
              <template #append>
                <el-button type="primary" class="sendCodeBtn" v-if="!getCodeDisabled" @click="get_code">
                  {{ getCaptcha }}
                </el-button>
                <el-button type="primary" class="sendCodeBtn" disabled v-else>{{ clock }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="图形验证码：" v-show="needImgVerifyCode">
            <div class="imgVerifyCode" style="">
              <el-input class="imgVerifyCode_input" v-model="imgVerifyCode">
                <img slot="suffix" id="imgVerifyCode" alt="点击更换" title="点击更换" @click="changeImg"/>
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
                  <el-button @click="returnBack" size="small">取 消</el-button>
                  <el-button type="primary" @click="confirm" size="small">确定</el-button></span>
    </el-dialog>

    <el-dialog title="温馨提示" :visible.sync="showConfirm">
      <el-form>
        <div style="font-size: 18px">你确定要重置数据访问密码吗？</div>
        <div style="color:#A8A8A8">请注意：重置数据访问密码立即生效，所有使用旧数据访问密码的数据传输立即失效。</div>
        <div style="color:#A8A8A8">为确组态平台的正常使用，请尽快更新终端传输数据访问密码。</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="returnBack">取 消</el-button>
        <el-button type="primary" @click="setCompanyPassword">确定重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "../../../../config/api";

export default {
  name: "SetDataPassword",
  props: {
    companyId: String,
  },
  data() {
    return {
      needImgVerifyCode: false,
      imgVerifyCode: '',
      companyTel: '', //公司绑定的电话号码
      captcha: '', //验证码
      getCodeDisabled: false,
      getCaptcha: '获取验证码',
      clock: '',
      showConfirm: false,//确认重置
      showSelf: true,//展示重置密码
    }
  },
  mounted() {
    this.getCompanyTel()
  },
  methods: {
    returnBack() {
      this.$emit('returnBack');
      this.showSelf = false;
    },
    //获取公司绑定的电话号码
    getCompanyTel() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId
      }
      this.$axiosRequest({
        url: API.getCompanyTel,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.companyTel = res.data.companyTelInfo.bindingTel;
        }
      });
    },
    // 获取验证码
    get_code() {
      let self = this;
      if (self.needImgVerifyCode && self.imgVerifyCode == '') {
        self.$message({type: 'warning', message: '图片验证码不应该为空'});
      } else {
        self.getCodeDisabled = true;
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }
        let data = {
          type: 3,
          phoneNumber: self.companyTel,
          imgVerifyCode: self.imgVerifyCode
        }
        this.$axiosRequest({
          url: API.sendCode,
          method: 'GET',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.$message({type: 'success', message: '验证码发送成功'});
              self.testIfNeedImgVerifyCode();// 每次验证码发送成功后，测试下一次是否需要图片验证码
            } else if (res.data == 1) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
            } else if (res.data == 2) {
              self.$message({type: 'warning', message: '请先输入图片验证码后才可获取短信验证码'});
            } else {
              self.$message({type: 'warning', message: '获取验证码失败，请稍后再试'});
            }
          }
        });
        let time = 59;
        self.clock = time + "s后重新发送";
        let cleartime = setInterval(() => {
          if (time <= 0) {
            self.clock = "重新获取";
            self.getCodeDisabled = false;
            clearInterval(cleartime);
            return false;
          }
          time -= 1;
          self.clock = time + "s后重新发送";
        }, 1000);
      }
    },
    changeImg() {
      let imgVerifyCode = document.getElementById("imgVerifyCode");
      imgVerifyCode.src = this.$axios.defaults.baseURL + "/message/getImgVerifyCode?time=" + Math.random(1000) + "&phoneNumber=" + this.companyTel;
      console.log("change: imgVerifyCode.src:", imgVerifyCode.src);
    },
    testIfNeedImgVerifyCode() {
      let self = this;
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.companyTel)) {
        return
      }
      if (!self.needImgVerifyCode) {// 如果needImgVerifyCode已经为true了，就不要再调用接口判断了，直接更换验证码图片
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {}
        this.$axiosRequest({
          url: API.testIfNeedImgVerifyCodeSend,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.needImgVerifyCode = true;
              self.changeImg();
            }
          }
        });
      } else {
        self.changeImg();
      }
    },
    //确认重置按钮
    confirm() {
      this.showConfirm = true;
      this.showSelf = false;
    },
    //获取公司基本信息
    setCompanyPassword() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        smsVerifyCode: this.captcha
      }
      this.$axiosRequest({
        url: API.setCompanyPassword,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data.companyPasswordInfo) {
            this.showConfirm = false;
            this.$emit('returnBack')
            this.$emit('returnCompanyPassword', res.data.companyPasswordInfo.companyPassword)
          } else {
            this.$message({type: 'warning', message: res.data.error});
            this.showConfirm = false;
            this.$emit('returnBack')
          }
        }
      });
    },


  }
}
</script>

<style scoped lang="less">
#SetDataPassword {
  //.captcha {
  //  margin-left: 70px;
  //  //height: 40px;
  //}
  //
  //.captcha > div > div {
  //  width: 60%;
  //}
  //
  //.captcha input {
  //  border: none;
  //  border-bottom: solid 1px white;
  //  border-radius: 0px;
  //  float: left;
  //}
  //
  //.captcha button {
  //  width: 31% !important;
  //  padding: 12px 14px;
  //  float: right;
  //  background-color: #388cd7;
  //  color: white;
  //}
  .pcPersonCenter_dialog {
    padding: 0px 0px 20px 0px;

    &.el-dialog {
      width: 576px;
    }

    &.el-dialog__body {
      padding: 10px !important;
    }
  }

  .sendCodeBtn {
    float: right;
  }

  .imgVerifyCode {
    position: relative;
    margin: 0 auto;

    .imgVerifyCode_input {
      display: inline-block;
    }

    img {
      display: inline-block;
      height: 38px;
      border-radius: 0 4px 4px 0;
      border-left: 1px solid #C0C4CC;
      margin: 1px 0;
      left: 4px;
      position: relative;
    }
  }


}

</style>